import type { IOption } from "./DropdownOption";
import { dropdownOptionRowClasses } from "./DropdownOption";
import { listboxOptionRowHandlersFromConfig, type ListboxOptionRowHandlers } from "@Front/Utils/interactiveElementA11y";

export function dropdownMenuOptionRowHandlers(
	option: IOption,
	ns: boolean,
	handleSelect: (o: IOption) => void,
): ListboxOptionRowHandlers {
	return listboxOptionRowHandlersFromConfig({
		className: dropdownOptionRowClasses["root"],
		tabIndex: ns ? -1 : 0,
		mouseDownPreventDefault: !ns,
		allowKeyboardActivate: !ns,
		onActivate: (): void => {
			handleSelect(option);
		},
	});
}
